export const DEFAULT_SHARE_SETTINGS = {
  emailSubject:
    "{{tenantName}} vous partage des documents",

  outboundMessage: [
    "Bonjour {{firstName}},",
    "",
    "{{tenantName}} vous a partagé les documents suivants :",
    "",
    "{{documents}}",
    "",
    "Vous pouvez les consulter depuis votre espace sécurisé :",
    "{{shareUrl}}",
    "",
    "Bonne consultation.",
    "",
    "{{senderName}}",
  ].join("\n"),

  welcomeMessage: [
    "Bonjour {{firstName}},",
    "",
    "Bienvenue sur votre espace de partage.",
    "",
    "Je vous ai partagé les documents suivants :",
    "{{documents}}",
  ].join("\n"),
};


function settingValue(
  settings,
  key
) {
  const value = settings?.[key];

  if (
    typeof value !== "string"
    || !value.trim()
  ) {
    return "";
  }

  return value;
}


export function resolveShareSettings(
  userSettings = {},
  tenantSettings = {}
) {
  return {
    emailSubject:
      settingValue(
        userSettings,
        "emailSubject"
      )
      || settingValue(
        tenantSettings,
        "emailSubject"
      )
      || DEFAULT_SHARE_SETTINGS.emailSubject,

    outboundMessage:
      settingValue(
        userSettings,
        "outboundMessage"
      )
      || settingValue(
        tenantSettings,
        "outboundMessage"
      )
      || DEFAULT_SHARE_SETTINGS.outboundMessage,

    welcomeMessage:
      settingValue(
        userSettings,
        "welcomeMessage"
      )
      || settingValue(
        tenantSettings,
        "welcomeMessage"
      )
      || DEFAULT_SHARE_SETTINGS.welcomeMessage,
  };
}


export function renderShareTemplate(
  template,
  context = {}
) {
  return String(template || "").replace(
    /\{\{([A-Za-z][A-Za-z0-9]*)\}\}/g,
    (match, key) => {
      if (
        context[key] === undefined
        || context[key] === null
      ) {
        return "";
      }

      return String(context[key]);
    }
  );
}


export function buildShareTemplateContext({
  prospect,
  user,
  tenantName,
  documents = [],
  shareUrl = "",
}) {
  const firstName =
    prospect?.firstName
    || prospect?.first_name
    || "";

  const lastName =
    prospect?.lastName
    || prospect?.last_name
    || "";

  const senderName =
    [
      user?.firstName,
      user?.lastName,
    ]
      .filter(Boolean)
      .join(" ")
    || user?.email
    || "";

  const documentList =
    documents
      .filter(Boolean)
      .map((name) => `- ${name}`)
      .join("\n");

  return {
    firstName,
    lastName,
    company:
      prospect?.company || "",
    tenantName:
      tenantName
      || user?.tenant?.name
      || "",
    senderName,
    documents: documentList,
    shareUrl,
  };
}
